"use client";
import { useAtomValue } from "jotai";
import { Suspense, useEffect } from "react";
import FullStory, { FullStoryAPI } from "react-fullstory";
import { sessionAtom, currentAccountIdAtom } from "@zapier/canvas-state";

declare global {
  interface Window {
    Intercom: (
      action: string,
      options?: number | Record<string, string | undefined>,
    ) => void;
  }
}

export default function ThirdPartyIntegrations() {
  const authState = useAtomValue(sessionAtom);
  const accountId = useAtomValue(currentAccountIdAtom);

  useEffect(() => {
    if (
      authState !== null &&
      (process.env.VERCEL_ENV !== "development" ||
        typeof window !== "undefined")
    ) {
      const { first_name, last_name, email } = authState;
      // Identify method
      const fullName = `${first_name} ${last_name}`;
      // @ts-ignore identify is sure as heck a correct value here
      FullStoryAPI("identify", authState.id, {
        email,
        fullName,
        accountId,
      });
    }
  }, [authState, accountId]);

  if (
    [process.env.VERCEL_ENV, process.env.NEXT_PUBLIC_VERCEL_ENV].includes(
      "development",
    )
  ) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <FullStory org="1XM" />
    </Suspense>
  );
}
